import React from 'react'

export type ShellLayout = { navWidth: number; iconOnly: boolean }

const ShellLayoutContext = React.createContext<ShellLayout>({ navWidth: 56, iconOnly: true })

export const ShellLayoutProvider: React.FC<{ value: ShellLayout; children: React.ReactNode }> = ({
  value,
  children,
}) => <ShellLayoutContext.Provider value={value}>{children}</ShellLayoutContext.Provider>

export function useShellLayout(): ShellLayout {
  return React.useContext(ShellLayoutContext)
}

/**
 * DOM node for the shell's full-width top bar, left end. Pages portal page-specific
 * controls (e.g. the chat conversation picker) into this slot. Null when there is no
 * top bar (e.g. mobile layout), in which case pages should render their own header.
 */
const ShellTopBarSlotContext = React.createContext<HTMLElement | null>(null)

export const ShellTopBarSlotProvider: React.FC<{ value: HTMLElement | null; children: React.ReactNode }> = ({
  value,
  children,
}) => <ShellTopBarSlotContext.Provider value={value}>{children}</ShellTopBarSlotContext.Provider>

export function useShellTopBarSlot(): HTMLElement | null {
  return React.useContext(ShellTopBarSlotContext)
}
